import HeaderSection from "../../../components/headerSection";
import ImageTextCard from "../../../components/imageTextCard";
import Footer from "../home/footer";
export default function Events() {
  const obj = [
    {
      description:
        "Access AI tools, guides, and resources to boost your career",
    },
    {
      description:
        "Get industry insights and upskilling opportunities to stay competitive.",
    },
  ];
  const obj2 = [
    {
      title: "Time Savings:",
      description:
        "Automate repetitive and routine tasks with AI tools, freeing up valuable time to focus on high-priority, strategic projects that drive innovation, productivity, and business growth.",
    },
    {
      title: "Data-Driven Decisions:",
      description:
        "Use AI tools to quickly analyze complex datasets, providing accurate insights and enabling informed decision-making for better outcomes.",
    },
    {
      title: "Cost Efficiency & Collaboration:",
      description:
        "Reduce operational costs by streamlining workflows and enhancing team collaboration through AI-powered communication and task management tools",
    },
    {
      title: "Interactive Feature:",
      description:
        "Select your current job role to discover AI productivity tools specifically designed to enhance your efficiency and adaptability in the workplace.",
    },
    {
      title: "Enhanced Collaboration:",
      description:
        " AI-powered tools enhance teamwork by streamline communication, automating tasks, & optimizing project management, boosting efficiency and collaboration.",
    },
  ];

  const obj3 = [
    {
      title: "Scholarships and Funding Opportunities",
      description:
        "Access scholarships, grants, and funding opportunities to make upskilling more affordable and accessible. These resources offer financial support for enhancing skills, particularly in AI and technology, helping you stay competitive in the evolving job market.",
    },
    {
      title: "Government and Nonprofit Resources for Upskilling:",
      description:
        "Explore government and nonprofit programs offering cost-effective or free courses to enhance your skills.",
    },
  ];

  const obj4 = [
    {
      title: "Healthcare:",
      description:
        "Gain insights into how AI is revolutionizing patient care, improving diagnostics, and transforming healthcare job roles, creating new opportunities and reshaping traditional practices.",
    },
    {
      title: "Finance:",
      description:
        "Delve into AI's impact on financial services, including automated trading, fraud detection systems, risk assessment tools, and personalized financial management solutions.",
    },
    {
      title: "Retail & E-commerce:",
      description:
        "Explore how AI enhances personalized shopping, customer behavior analysis, inventory, and supply chain management to boost satisfaction and efficiency.",
    },
    {
      title: "Manufacturing & Education:",
      description:
        "Uncover AI-driven innovations in manufacturing automation and evolving educational tools, focusing on skill development and industry adaptability.",
    },
  ];

  const obj5 = [
    {
      title: "The Future of Jobs:",
      description:
        "Gain a detailed understanding of how AI reshapes industries, projected job growth, and new opportunities for AI-resilient careers.",
    },
    {
      title: "AI in the Workforce:",
      description:
        "Explore sector-specific analyses of AI's transformative effects, highlighting areas at high risk for automation and those set to thrive.",
    },
    {
      title: "Skills for the AI Economy:",
      description:
        " Learn about the most in-demand skills for thriving in an AI-driven market, with guidance on acquiring and honing these critical competencies",
    },
    {
      title: "Impact of AI on Small Businesses:",
      description:
        "Uncover AI-driven innovations in manufacturing automation and evolving educational tools, focusing on skill development and industry adaptability.",
    },
    {
      title: "Digital Transformation and Inclusion:",
      description:
        "Insights on how AI is impacting workforce inclusion, with recommendations on creating equitable workplaces in the age of AI.",
    },
  ];
  return (
    <div>
      <HeaderSection
        title="AI Career Resource Hub"
        description="Your go-to hub for AI tools, career insights, and resources to thrive in an AI-driven workplace"
        descriptionClass="w-[571px]"
        header={"Coming Soon!"}
      />
      <ImageTextCard
        image="/RH1.jpg"
        imageClass="w-[640px] h-auto"
        label="Welcome to Your AI Career Resource Hub"
        subTitle="Explore our comprehensive resources designed to empower your career journey in the AI-driven workplace. Enhance your adaptability, upskill, and stay ahead with our tailored tools and insights."
        subTitleClass="text-base font-bold text-border-gray"
        obj={obj}
        pointIcon="/pink-check.png"
        pointIconClass="w-5 h-5 mt-2"
      />
      <ImageTextCard
        image="/RH2.jpg"
        imageClass="w-[640px] h-auto"
        label="AI Tools for Productivity"
        subTitle="Leverage cutting-edge AI tools to automate repetitive tasks, improve decision-making, and boost workplace efficiency. Our curated selection enhances individual and team productivity by streamlining workflows."
        obj={obj2}
        pointIcon="/pink-check.png"
        pointIconClass="w-5 h-5 mt-1"
        position="left"
      />
      <ImageTextCard
        image="/RH3.jpg"
        imageClass="w-[640px] h-auto"
        label="AI Education & Upskilling Resources"
        subTitle="Access scholarships, grants, and government or nonprofit programs that provide free or subsidized upskilling opportunities for those impacted by AI and automation."
        obj={obj3}
        pointIcon="/pink-check.png"
        pointIconClass="w-5 h-5 mt-1"
      />
      <ImageTextCard
        image="/RH4.jpg"
        imageClass="w-[640px] h-auto"
        label="Industry-Specific AI Guides"
        subTitle="Discover how AI is reshaping your industry, revolutionizing job roles, and creating new opportunities. Our detailed guides provide insights and strategies to help you adapt, thrive, and stay competitive in the evolving AI landscape."
        obj={obj4}
        position="left"
        pointIcon="/pink-check.png"
        pointIconClass="w-5 h-5 mt-1"
      />
      <ImageTextCard
        image="/RH5.jpg"
        imageClass="w-[640px] h-auto"
        label="Reports and Research"
        subTitle="Stay informed with our comprehensive reports and white papers, offering deep insights into AI's impact on the job market and essential industry trends"
        obj={obj5}
        pointIcon="/pink-check.png"
        pointIconClass="w-5 h-5 mt-1"
      />
      <Footer />
    </div>
  );
}
